// export const Privillages = [
//     [ name:"پنل دیجی‌کالا","مشاهده","ثبت","حذف","ویرایش"],
//     ["لیست کالاها","مشاهده","ویرایش"],
//     ["لیست تنوع‌ها","مشاهده","به‌روز رسانی","ویرایش"],
//     ["پنل قیمت‌گذاری","مشاهده","ویرایش"],
//     ["مدیریت کاربران","مشاهده کاربران","تعریف کاربر جدید","تعریف سطح دسترسی جدید","ویرایش اطلاعات","حذف و تغییر وضعیت"]
// ]
//last version
// export const Privillages =
//  [{title:"پنل دیجی‌کالا",value:"DGPanel",parentId:"0",id:"1",check:"rsde" ,uncheck:"rsde"},
//  {title:"ویرایش",value:"edit",parentId:"1",id:"100",check:"re",uncheck:"e"},
//  {title:"حذف",value:"delete",parentId:"1",id:"101",check:"rd", uncheck:"d"},
//  {title:"مشاهده",value:"read",parentId:"1",id:"102",check:"r", uncheck:"rsde"},
//  {title:"ثبت",value:"submit",parentId:"1",id:"103",check:"rs", uncheck:"s"},
//  {title:"لیست کالاها",value:"productList",parentId:"0",id:"2",check:"re", uncheck:"re"},
//  {title:"ویرایش",value:"edit",parentId:"2",id:"200",check:"re", uncheck:"e"},
//  {title:"مشاهده",value:"read",parentId:"2",id:"201",check:"r", uncheck:"re"},
//  {title:"لیست تنوع‌ها",value:"variantList",parentId:"0",id:"3",check:"rue", uncheck:"rue"},
//  {title:"مشاهده",value:"read",parentId:"3",id:"300",check:"r", uncheck:"rue"},
//  {title:"ویرایش",value:"edit",parentId:"3",id:"301",check:"re", uncheck:"e"},
//  {title:"به‌روز رسانی",value:"update",parentId:"3",id:"302",check:"ru", uncheck:"u"},
//  {title:"پنل قیمت‌گذاری",value:"pricingPanel",parentId:"0",id:"4",check:"re", uncheck:"re"},
//  {title:"مشاهده",value:"read",parentId:"4",id:"400",check:"r", uncheck:"re"},
//  {title:"ویرایش",value:"edit",parentId:"4",id:"401",check:"re", uncheck:"e"},
//  {title:"مدیریت کاربران",value:"userManagement",parentId:"0",id:"5",check:"raped", uncheck:"raped"},
//  {title:"مشاهده کاربران",value:"read",parentId:"5",id:"500",check:"r", uncheck:"raped"},
//  {title:"ویرایش اطلاعات",value:"edit",parentId:"5",id:"501",check:"re", uncheck:"e"},
//  {title:"حذف و تغییر وضعیت",value:"delete",parentId:"5",id:"502",check:"rd", uncheck:"d"},
//  {title:"تعریف کاربر جدید",value:"addUser",parentId:"5",id:"503",check:"ra", uncheck:"a"},
//  {title:"تعریف سطح دسترسی جدید",value:"addPrivillage",parentId:"5",id:"504",check:"rp", uncheck:"p"}
// ]

export const Privillages =
    [{
        title: "پنل دیجی‌کالا",
        value: "DGPanel",
        parentId: "0",
        id: "1",
        check: "ReadAddDeleteEdit",
        uncheck: "ReadAddDeleteEdit"
    },
        {title: "ویرایش", value: "edit", parentId: "1", id: "100", check: "ReadEdit", uncheck: "Edit"},
        {title: "حذف", value: "delete", parentId: "1", id: "101", check: "ReadDelete", uncheck: "Delete"},
        {title: "مشاهده", value: "read", parentId: "1", id: "102", check: "Read", uncheck: "ReadAddEditDelete"},
        {title: "ثبت", value: "submit", parentId: "1", id: "103", check: "ReadAdd", uncheck: "Add"},
        {title: "لیست کالاها", value: "productList", parentId: "0", id: "2", check: "ReadEdit", uncheck: "ReadEdit"},
        {title: "ویرایش", value: "edit", parentId: "2", id: "200", check: "ReadEdit", uncheck: "Edit"},
        {title: "مشاهده", value: "read", parentId: "2", id: "201", check: "Read", uncheck: "ReadEdit"},
        {
            title: "لیست تنوع‌ها",
            value: "variantList",
            parentId: "0",
            id: "3",
            check: "ReadUpdateEdit",
            uncheck: "ReadUpdateEdit"
        },
        {title: "مشاهده", value: "read", parentId: "3", id: "300", check: "Read", uncheck: "ReadUpdateEdit"},
        {title: "ویرایش", value: "edit", parentId: "3", id: "301", check: "ReadEdit", uncheck: "Edit"},
        {title: "به‌روز رسانی", value: "update", parentId: "3", id: "302", check: "ReadUpdate", uncheck: "Update"},
        {
            title: "پنل قیمت‌گذاری",
            value: "pricingPanel",
            parentId: "0",
            id: "4",
            check: "ReadEdit",
            uncheck: "ReadEdit"
        },
        {title: "مشاهده", value: "read", parentId: "4", id: "400", check: "Read", uncheck: "ReadEdit"},
        {title: "ویرایش", value: "edit", parentId: "4", id: "401", check: "ReadEdit", uncheck: "Edit"},
        {
            title: "مدیریت کاربران",
            value: "userManagement",
            parentId: "0",
            id: "5",
            check: "ReadAddPermissionEditDelete",
            uncheck: "ReadAddPermissionEditDelete"
        },
        {
            title: "مشاهده کاربران",
            value: "read",
            parentId: "5",
            id: "500",
            check: "Read",
            uncheck: "ReadAddPermissionEditDelete"
        },
        {title: "ویرایش اطلاعات", value: "edit", parentId: "5", id: "501", check: "ReadEdit", uncheck: "Edit"},
        {title: "حذف و تغییر وضعیت", value: "delete", parentId: "5", id: "502", check: "ReadDelete", uncheck: "Delete"},
        {title: "تعریف کاربر جدید", value: "addUser", parentId: "5", id: "503", check: "ReadAdd", uncheck: "Add"},
        {
            title: "تعریف سطح دسترسی جدید",
            value: "addPrivillage",
            parentId: "5",
            id: "504",
            check: "ReadPermission",
            uncheck: "Permission"
        },
        {
            title: "مدیریت گزارشات",
            value: "reportManagement",
            parentId: "0",
            id: "6",
            check: "ReadAddReportEditDelete",
            uncheck: "ReadAddReportEditDelete"
        },
        {
            title: "مشاهده گزارش‌ها",
            value: "read",
            parentId: "6",
            id: "600",
            check: "Read",
            uncheck: "ReadAddReportEditDelete"
        },
        {title: "ویرایش گزارش‌ها", value: "edit", parentId: "6", id: "601", check: "ReadEdit", uncheck: "Edit"},
        {
            title: "حذف و تغییر گزارش‌ها",
            value: "delete",
            parentId: "6",
            id: "602",
            check: "ReadDelete",
            uncheck: "Delete"
        },
        {title: "ساخت گزارش‌ جدید", value: "addReport", parentId: "6", id: "603", check: "ReadAdd", uncheck: "Add"},
        {
            title: "مشاهده لیست گزارش‌ها",
            value: "readReportList",
            parentId: "6",
            id: "604",
            check: "ReadReport",
            uncheck: "Report"
        },

    ]